export default __webpack_public_path__ + "static/media/iconsDesc.fb533a43.png";